import { render, staticRenderFns } from "./ContaDetail.vue?vue&type=template&id=c9fdf312&scoped=true"
import script from "./ContaDetail.vue?vue&type=script&lang=js"
export * from "./ContaDetail.vue?vue&type=script&lang=js"
import style0 from "./ContaDetail.vue?vue&type=style&index=0&id=c9fdf312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fdf312",
  null
  
)

export default component.exports